import { useNavigate } from 'react-router-dom';

import { NavigationService } from '../../services/navigation.service';

import { Client, Site } from '@umanforge/common';

import { ClientsIcon } from '../icons/clients_icon.component';


interface SiteProps {
  site: Site;
  clientOfSite: Client | undefined;
  t: ( key: string ) => string;
}

export function SiteComponent( props: SiteProps ) {
  const { site, clientOfSite, t } = props;

  const navigate = useNavigate();

  function openDetailsSite() {
    NavigationService.toSite( navigate, site.id, false );
  }

  return (
    <div
      className="relative flex px-24 py-4 mx-2 my-4 shrink-0 text-center justify-center items-center bg-gray-100 shadow-md drop-shadow-md overflow-hidden rounded-lg cursor-pointer transition ease-in-out hover:-translate-y-1 hover:scale-[105%] hover:drop-shadow-xl hover:z-10 duration-50"
      style={{ width: '26rem' }}
      onClick={ openDetailsSite }
    >
      <p className="text-lg font-semibold text-slate-600 text-center truncate">{ site.name }</p>
      <div className='absolute flex flex-col w-20 px-2 my-2 items-center justify-around inset-y-0 right-0 text-xs font-medium text-slate-500 text-left'>
        <div className='flex gap-1 w-20'>
          <ClientsIcon className='fill-slate-500 w-3'/>
          <p className='w-full truncate'>{ clientOfSite ? clientOfSite.name : t( 'common:error.missing_client' ) }</p>
        </div>
      </div>
    </div>
  );
}